import { PulseLoader } from 'react-spinners'

export const Loading = () => {
  return (
    <div className="fixed top-0 left-0 z-1300 h-screen w-full bg-white">
      <PulseLoader
        color="#1C50B9"
        margin={10}
        size={10}
        speedMultiplier={1}
        className="absolute top-1/2 left-1/2 -translate-x-1/2"
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}
